import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import HeaderLinks from './HeaderLinks';
import GetStartedCta from './GetStartedCta';
import LanguageSelector from './LanguageSelector';
import { type } from '../../../styles/typography';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  padding: 88px var(--b-gutter) 40px;
  background-color: var(--b-black);
  color: var(--b-white);
`;

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 20px;

  a {
    ${type('headline', 'medium')};
    color: var(--b-white);

    &.active {
      color: rgba(255, 255, 255, 0.56);
    }
  }
`;

const Language = styled.div`
  display: flex;
  margin-top: 48px;
`;

const Cta = styled.div`
  margin-top: auto;
  padding-top: 48px;

  a {
    ${type('label', 'large', { emphasis: true })};
    width: 100%;
  }
`;

const MobileMenuContent = ({ closeMenu }) => (
  <Content id="hamburgerMenuContent">
    <Nav>
      <HeaderLinks closeMenu={closeMenu} />
    </Nav>
    <Language>
      <LanguageSelector />
    </Language>
    <Cta>
      <GetStartedCta size="large" trackingData={{ from: 'Mobile Menu' }} />
    </Cta>
  </Content>
);

MobileMenuContent.propTypes = {
  closeMenu: PropTypes.func,
};

export default MobileMenuContent;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/header/MobileMenuContent.js